export const replaceSpecialChars = (str: string): string => {
  let string = str;
  if (string.endsWith(' A') || string.endsWith(' B')) {
    string = string.substring(0, string.length - 2);
  }
  return string
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/([^\w]+|\s+)/g, '-'); // Replace space and other characters by hyphen
};

export const savingsAccountUrl = '/henkiloasiakkaat/paivittaiset/tilit/';
